import { TabView } from '@/features/app-tabs/tab-view';

/** Food & Cafe landing tab — reference consumer of GET /user/food-cafe. */
export function FoodCafeTabPage() {
  return <TabView tab="food-cafe" title="Food & Cafe" />;
}
